/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiButtonEmpty } from '@elastic/eui'

import { withErrorBoundary } from '@modules/cui/Boundary'

import ConvertOrganizationFlyout from './ConvertOrganizationFlyout'
import { messages } from './messages'

import type { ConvertOrganizationButtonProps } from './types'
import type { FunctionComponent } from 'react'

const ConvertOrganizationButton: FunctionComponent<ConvertOrganizationButtonProps> = ({
  activateOrganization,
  deactivateOrganization,
  activateOrganizationRequest,
  deactivateOrganizationRequest,
  email,
  convertType,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const convertMethod = {
    activate: activateOrganization,
    deactivate: deactivateOrganization,
  }[convertType]
  const convertRequest = {
    activate: activateOrganizationRequest,
    deactivate: deactivateOrganizationRequest,
  }[convertType]
  const convertMessage = {
    activate: messages.activateOrganization,
    deactivate: messages.deactivateOrganization,
  }[convertType]

  return (
    <Fragment>
      <EuiButtonEmpty size='s' onClick={() => setModalOpen(true)}>
        <FormattedMessage {...convertMessage} />
      </EuiButtonEmpty>

      {modalOpen && (
        <ConvertOrganizationFlyout
          convertOrganization={convertMethod}
          convertOrganizationRequest={convertRequest}
          convertType={convertType}
          email={email}
          onClose={() => setModalOpen(false)}
        />
      )}
    </Fragment>
  )
}

export default withErrorBoundary(ConvertOrganizationButton)
